module.exports = __webpack_public_path__ + "static/media/Shell_logo.fed37460.svg";